import React from 'react'
import { cn } from '../../lib/utils'
import { Slide } from '../presentation/Slide'
import type { SlideData, SlideTransition } from '../../types'

export interface NextSlidePreviewProps {
  nextSlide: SlideData | null
  transition?: SlideTransition
  className?: string
}

/**
 * NextSlidePreview Component
 *
 * Shows a preview of the next slide in presenter mode.
 * Displays at reduced scale to fit in the presenter panel.
 */
export const NextSlidePreview: React.FC<NextSlidePreviewProps> = ({
  nextSlide,
  transition = 'fade',
  className,
}) => {
  if (!nextSlide) {
    return (
      <div className={cn(
        'w-full h-48 bg-muted rounded-lg',
        'flex items-center justify-center',
        'border-2 border-dashed border-border',
        className
      )}>
        <p className="text-sm text-muted-foreground">
          End of presentation
        </p>
      </div>
    )
  }

  return (
    <div className={cn('relative', className)}>
      <div className="text-xs font-medium text-muted-foreground mb-2 uppercase tracking-wide">
        Next Slide
      </div>
      <div
        className={cn(
          'w-full aspect-video rounded-lg overflow-hidden',
          'border border-border',
          'shadow-sm'
        )}
      >
        {/* Render the slide in a scaled container */}
        <div className="w-full h-full scale-[0.25] origin-top-left">
          <Slide
            data={nextSlide}
            isActive={true}
            transition={transition}
            direction="forward"
          />
        </div>
      </div>
      {nextSlide.title && (
        <div className="mt-2 text-sm font-medium text-foreground truncate">
          {nextSlide.title}
        </div>
      )}
    </div>
  )
}

export default NextSlidePreview
